import {
  faCheck,
  faPencilAlt,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";

const EditableInputWithIcons = ({ value, setValue }) => {
  const [isActive, setIsActive] = useState(false);
  const [inputText, setInputText] = useState("");

  useEffect(() => {
    setInputText(value);
  }, [value]);

  return (
    <div className="editable-input">
      {isActive ? (
        <>
          <div className="input-field">
            <input
              autoFocus
              type="text"
              value={inputText}
              onBlur={() => {
                setValue(inputText);
                setIsActive(false);
              }}
              onChange={(e) => setInputText(e.target.value)}
            />
          </div>
        </>
      ) : (
        <div className="label" onClick={() => setIsActive(true)}>
          <p>{value}</p>
          <FontAwesomeIcon icon={faPencilAlt} />
        </div>
      )}
    </div>
  );
};
export default EditableInputWithIcons;
